import { apiCall } from "../../../_utils";
import { apiUrls } from "../../../_constants";

export const clientService = {
  getAllClients,
  addClient,
  getClient
};

function getAllClients() {
  return apiCall("GET", apiUrls.clients.base);
}

function addClient(request) {
  const method = request && request.id ? "PUT" : "POST";
  return apiCall(method, apiUrls.clients.base, request);
}

function getClient(id) {
  return apiCall("GET", `${apiUrls.clients.base}/${id}`);
}

